import { ContractReviewState, ContractReviewUnloadState } from '../../states/ContractReview.States';
import * as actions from '../../actions/ContractReview.Actions';
import { sortByCreatedDesc } from './ContractReview.Shared';

/** Alta de una revisión: la nueva va primera en el historial del contrato. */
export default function ContractReviewCreateReducer(state: ContractReviewState | undefined, action: any): ContractReviewState {
  const current = state ?? ContractReviewUnloadState;
  switch (action.type) {
    case actions.CONTRACT_REVIEW_CREATE_REQUEST:
      return { ...current, isCreating: true, successCreating: undefined, createError: undefined, lastCreatedReviewId: undefined };
    case actions.CONTRACT_REVIEW_CREATE_SUCCESS: {
      const review = action.review;
      if (!review) return { ...current, isCreating: false, successCreating: true };
      const entry = current.listByContract[action.contractId] ?? { items: [], isLoading: false, success: true };
      return {
        ...current,
        isCreating: false,
        successCreating: true,
        lastCreatedReviewId: review.id,
        listByContract: {
          ...current.listByContract,
          [action.contractId]: { ...entry, items: sortByCreatedDesc([review, ...entry.items.filter(r => r.id !== review.id)]) }
        }
      };
    }
    case actions.CONTRACT_REVIEW_CREATE_FAILURE:
      return { ...current, isCreating: false, successCreating: false, createError: action.error };
    case actions.CONTRACT_REVIEW_CLEAR_CREATE_STATUS:
      return { ...current, isCreating: false, successCreating: undefined, createError: undefined, lastCreatedReviewId: undefined };
    default:
      return current;
  }
}
